import LegalPageLayout from "../components/LegalPageLayout";

function ContactSupport() {

    return (

        <LegalPageLayout title="Contact & Corporate Office Information">

            <p>KRPL - Customer Portal Services</p>

            <div className="legal-contact-block">

                <p><strong>Email:</strong> <a href="mailto:it@kinetiqrobotics.com">it@kinetiqrobotics.com</a></p>

                <p><strong>Phone:</strong> <a href="tel:+918451803253">+91-(845)-180-3253</a></p>

                <p style={{ marginTop: "14px" }}><strong>Registered Corporate Office:</strong></p>

                <p style={{ marginBottom: 0 }}>
                    Kinetiq Robotics Private Limited<br />
                    54/2, D2 Block, MIDC Chinchwad,<br />
                    Pune, MH, India - 411045
                </p>

            </div>

            <p style={{ marginTop: "20px" }}>
                For queries regarding data rights or to reach our designated Data Protection Officer
                (DPO), please use the email address above - see our <a href="/privacy-policy">Privacy
                Policy</a> for more on how your data is handled.
            </p>

        </LegalPageLayout>

    );

}

export default ContactSupport;
